import { render, staticRenderFns } from "./ArticlePickerBtn.vue?vue&type=template&id=ce0e5c58&scoped=true&"
import script from "./ArticlePickerBtn.vue?vue&type=script&lang=js&"
export * from "./ArticlePickerBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0e5c58",
  null
  
)

export default component.exports